import { render, staticRenderFns } from "./ColumnItemText.vue?vue&type=template&id=fec8c1c0&scoped=true&"
import script from "./ColumnItemText.vue?vue&type=script&lang=ts&"
export * from "./ColumnItemText.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnItemText.vue?vue&type=style&index=0&id=fec8c1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec8c1c0",
  null
  
)

export default component.exports